import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Prepend Vite base path to a public asset path (e.g. "/avatars/x.svg" → "/avatars/x.svg") */
const BASE = import.meta.env.BASE_URL.replace(/\/$/, '')
export function assetUrl(path: string): string {
  return `${BASE}${path.startsWith('/') ? path : `/${path}`}`
}
